import React, { useState, useEffect } from "react";
import { Button, Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Banner.css";

const API_URL = "https://madhusewingmachines.com/api/banner";

const Banner = () => {
  const navigate = useNavigate();
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        console.log("Frontend Banner: Fetching from", API_URL);
        const response = await axios.get(API_URL);
        console.log("Frontend Banner: Response received", response.data);
        console.log("Frontend Banner: Is array?", Array.isArray(response.data));
        
        const bannersData = Array.isArray(response.data) ? response.data : [response.data];
        console.log("Frontend Banner: Banners data", bannersData);
        console.log("Frontend Banner: Total banners", bannersData.length);
        
        // Filter only active banners
        const activeBanners = bannersData.filter(banner => banner.isActive !== false);
        console.log("Frontend Banner: Active banners", activeBanners.length);
        
        setBanners(activeBanners);
      } catch (error) {
        console.error("Frontend Banner: Error fetching banners:", error);
        setError("Failed to load banners.");
      } finally {
        setLoading(false);
      }
    };
    fetchBanners();
  }, []);

  const handleBuyNow = () => {
    navigate("/ProductPage");
  };

  return (
    <div className="banner-container">
      {loading && <p className="text-center">Loading banners...</p>}
      {error && <p className="text-danger text-center">{error}</p>}

      {!loading && banners.length > 0 && (
        <Carousel 
          fade 
          interval={3000} 
          controls={banners.length > 1} 
          indicators={banners.length > 1}
          pause="hover"
        >
          {banners.map((banner, index) => (
            <Carousel.Item key={banner._id}>
              <div className="banner-container" style={{ position: 'relative', width: '100%', height: '600px' }}>
                <img
                  src={`https://madhusewingmachines.com/uploads/${banner.image}`}
                  alt={banner.title}
                  className="banner-background"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  onError={(e) => {
                    console.error("Frontend Banner: Image failed to load");
                    console.error("Image filename:", banner.image);
                    console.error("Full URL:", e.target.src);
                  }}
                  onLoad={() => {
                    console.log("Frontend Banner: Image loaded successfully:", banner.image);
                  }}
                />
                <div className="banner-content">
                  <span className="highlight-badge">New Arrival</span>
                  <h1 className="banner-title" style={{ color: banner.textColor || '#000000' }}>
                    {banner.title ||
                      "Buy sewing machines from Madhu Sewing Machine @ Best Price"}
                  </h1>
                  <p className="banner-description" style={{ color: banner.textColor || '#000000' }}>
                    {banner.description ||
                      "Explore top-quality sewing machines with the best deals."}
                  </p>
                  <Button className="banner-button" onClick={handleBuyNow}>
                    Buy Now
                  </Button>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      )}

      {!loading && banners.length === 0 && (
        <div className="text-center p-5">
          <p className="text-muted">No banners available at the moment.</p>
        </div>
      )}
    </div>
  );
};

export default Banner;
